import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue';
import VueCompositionApi from '@vue/composition-api';
Vue.use(VueCompositionApi);
import Buefy from 'buefy';
import moment from 'moment';
import 'moment-timezone';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import copy from 'fast-copy';
import VueFuse from 'vue-fuse';

import Amplify, { Auth } from 'aws-amplify';
import amplifyConfig from './amplify-config.js';

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: amplifyConfig.cognito.REGION,
    userPoolId: amplifyConfig.cognito.USER_POOL_ID,
    userPoolWebClientId: amplifyConfig.cognito.APP_CLIENT_ID,
  },
  API: {
    endpoints: [
      {
        name: 'omw',
        endpoint: amplifyConfig.apiGateway.URL,
        region: amplifyConfig.apiGateway.REGION,
        custom_header: async () => {
          const token = (await Auth.currentSession())
            .getIdToken()
            .getJwtToken();
          return {
            Authorization: `Bearer ${token}`,
          };
        },
      },
    ],
  },
});

import utils from './mixins/utils.vue';
import i18nMixin from './mixins/i18n.vue';
import i18n from './lang/lang.js';
import configData from '@/config/config.json';
import store from './store/store-modules.js';
import App from '@/App.vue';
import './fontawesome.js';
import router from './router/index.js';
import { initialiseValidation } from './veeValidate.js';
import globalData from './mixins/globalData.vue';

Vue.component('VueFontawesome', FontAwesomeIcon);

Vue.prototype.$moment = moment;
Vue.$moment = moment;
Vue.prototype.$copy = copy;
Vue.$copy = copy;
Vue.$configData = Object.freeze(configData);
Vue.prototype.$configData = Object.freeze(configData);

Vue.mixin(globalData);
Vue.mixin(i18nMixin);
Vue.mixin(utils);

Vue.use(Buefy, {
  defaultIconComponent: 'vue-fontawesome',
  defaultIconPack: 'fad',
});
Vue.use(VueFuse);

export const app = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: (h) => h(App),
});

initialiseValidation(app.$t.bind(app));
